import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
export var DrawerContentBody = function DrawerContentBody(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      _a$hasPadding = _a.hasPadding,
      hasPadding = _a$hasPadding === void 0 ? false : _a$hasPadding,
      props = __rest(_a, ["className", "children", "hasPadding"]);

  return React.createElement("div", Object.assign({
    className: css(styles.drawerBody, hasPadding && styles.modifiers.padding, className)
  }, props), children);
};